/* eslint-disable indent */
import React, { useContext, useMemo, useState } from "react";

import { useLazyQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { FOLDER_RULES } from "shared/graphql/file/queries";
import { STATUS_INFO } from "shared/graphql/info/queries";

export const Context = React.createContext("statusInfo");
export const { Consumer } = Context;

const FolderStatus = ({ children }) => {
  const [code, setCode] = useState();
  const [getFolderRules, queryForms] = useLazyQuery(FOLDER_RULES, {
    fetchPolicy: "network-only",
  });
  const [getStatusInfo, queryStatus] = useLazyQuery(STATUS_INFO, {
    fetchPolicy: "network-only",
  });
  const forms = useMemo(
    () => queryForms?.data?.folderRules?.data?.forms || [],
    [queryForms?.data?.folderRules?.data?.forms],
  );
  const statusInfo = useMemo(
    () => queryStatus?.data?.statusInfo || {},
    [queryStatus?.data?.statusInfo],
  );

  const getStatusConfig = async ({ folderNum, actionCode, folderStatus }) => {
    const _code = actionCode
      ? {
          processCode: actionCode.split(":")[0],
          statusCode: actionCode.split(":")[1],
        }
      : folderStatus
      ? {
          processCode: folderStatus.processCode,
          statusCode: folderStatus.statusCode,
        }
      : null;
    setCode(_code);
    if (_code) {
      await getStatusInfo({
        variables: {
          where: {
            ..._code,
          },
        },
      });
      await getFolderRules({
        variables: {
          where: {
            ruleType: "FORMS",
            folderNum,
            ..._code,
          },
        },
      });
    }
  };

  return (
    <Context.Provider
      value={{
        getStatusConfig,
        forms,
        statusInfo,
        code,
        loading: queryForms.loading || queryStatus.loading,
      }}>
      {children}
    </Context.Provider>
  );
};
FolderStatus.propTypes = {
  children: PropTypes.node.isRequired,
};

export const Provider = FolderStatus;

export const useFolderStatus = () => {
  return useContext(Context);
};
